import { ClientStartupConfigService } from '../shared/shared-context/client-startup-config.service';

let resultPromise: Promise<string>;

async function getServiceWorkerUserId(
    clientStartupConfigService: ClientStartupConfigService
) {
    const { tenantId, puid } = clientStartupConfigService.config;
    return `${tenantId}_${puid}`;
}

export function serviceWorkerUserIdFactory(
    clientStartupConfigService: ClientStartupConfigService
): () => Promise<string> {
    // Provide a function that will obtain the service worker user ID lazily.
    // This is to ensure that getting the ID doesn't run during app startup
    return () => {
        if (!resultPromise) {
            resultPromise = getServiceWorkerUserId(clientStartupConfigService);
        }
        return resultPromise;
    };
}
